// Every phone card list - the ticket list, a user's Tickets tab, My Work's and My Group Work's lanes - loads this many
// cards at first and this many more each time it reaches the bottom. The desktop per-page setting (25, 50 or 100) is
// for a table drawing one page; on a phone every loaded card stays drawn, so 100 at a time was slow.
export const PHONE_PAGE_SIZE = 25;

// Tailwind's md breakpoint, where the lists swap their table or board for cards.
export const isPhoneWidth = (width: number) => width < 768;

export const cardListPageSize = (isPhone: boolean, otherwise: number) => (isPhone ? PHONE_PAGE_SIZE : otherwise);
